<template>
  <ProSpaceVLayout class="home-dashboard-comment" :gap="5" is-inline-h>
    <ProSpaceHLayout justify-content="space-between" :gap="10">
      <ProSpaceHLayout class="home-dashboard-comment__tagline" style="width: 70%;" :gap="5">
        <ProSpaceTag :type="typeTag" :text="textTag" />
        <ProSpaceTag type="gray-light" :text="id" bordered regular />
        <div v-if="agency" :title="agency" class="text-bold text-size-14 home-dashboard-comment__agency">{{ agency }}</div>
      </ProSpaceHLayout>
      <ProSpaceHLayout class="home-dashboard-comment__date" justify-content="end" style="width: calc(30% - 10px); white-space: nowrap">
        <div :title="formatDate" class="text-color-icon-gray text-size-11 text-ellipsis">
          {{ formatDate }}
        </div>
      </ProSpaceHLayout>
    </ProSpaceHLayout>
    <ProSpaceHLayout>
      <div class="text-color-main text-size-12 text-bold">
        {{ fio }}
      </div>
    </ProSpaceHLayout>
    <ProSpaceVLayout>
      <div class="text-color-icon-gray text-size-12">
        {{ $t('adjustmentComment') }}
      </div>
      <div class="text-color-gray text-size-12 home-dashboard-comment__content" :title="comment">
        {{ comment }}
      </div>
    </ProSpaceVLayout>
  </ProSpaceVLayout>
</template>

<script>
import {
    ProSpaceHLayout,
    ProSpaceVLayout,
    ProSpaceTag
} from "@prospace/prospace-components-library";
import { mapGetters } from "vuex";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
    name: "HomeDashboardComment",
    components: {
        ProSpaceHLayout,
        ProSpaceVLayout,
        ProSpaceTag
    },
    props: {
        id: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            required: true
        },
        status: {
            type: String,
            required: true
        },
        date: {
            type: Date,
            required: true
        },
        fio: {
          type: String,
          required: true
        },
        comment: {
          type: String,
          required: true
        },
        agency: {
          type: String,
          required: false
        }
    },
    data() {
      return {
        statuses: {
          onacceptance: 'light-blue',
          onapproval: 'blue',
          completed: 'teal'
        }
      }
    },
    computed: {
        ...mapGetters({
          userinfo: "userinfoStore/getUserinfo",
          getFormatDateTime: "userinfoStore/getFormatDateTime",
        }),
        textTag() {
            return this.$t('adjustment' + this.status)
        },
        typeTag() {
            return this.statuses[this.status]
        },
        formatDate() {
            return this.getFormatDateTime(this.date) + ' ' + getAMorPM(this.date, this.userinfo?.timeFormat);
        }
    }
}
</script>

<style lang="scss">
.home-dashboard-comment {
    padding: 10px;
    cursor: pointer;
    box-shadow: 0px 2px 10px rgba(51, 51, 51, 0.07);
    border-radius: 5px;
    width: calc(100% - 20px) !important;
    margin: 0 10px;
  &__content {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
  }
  &__agency {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &__tagline {
    @container (max-width: 1230px) {
      flex-wrap: wrap !important;
    }
  }
  &__date {
    @container (max-width: 1230px) {
      display: none !important;
    }
  }
}
</style>
